(function(){
  if(!document.getElementById('rs-red-theme-js')){
  var s = document.createElement('style');
  s.id = 'rs-red-theme-js';
  s.textContent =
    '.cs-section{background:#7f1d1d!important}' +
    '.cs-heading span,.cs-stat-num{color:#fca5a5!important}' +
    '.cs-cta{background:#f5f0e1!important;color:#7f1d1d!important}' +
    '.cs-stats .cs-stat+.cs-stat{border-color:rgba(252,165,165,0.2)!important}' +
    '.cp-title span{color:#b91c1c!important}' +
    '.st-stars,.st-card__stars{color:#b91c1c!important}' +
    '.st-title span{color:#b91c1c!important}' +
    '.st-verified{color:#b91c1c!important}' +
    '.st-tag{background:#fee2e2!important;color:#b91c1c!important}' +
    '.st-dot-active,.st-dots .swiper-pagination-bullet-active{background:#b91c1c!important}' +
    '.st-nav{color:#b91c1c!important;border-color:#b91c1c!important}' +
    '.fb-section{background:#7f1d1d!important}' +
    '.fb-icon-circle{background:#f87171!important}' +
    '.pb-title span{color:#b91c1c!important}' +
    '.pb-badge{background:#7f1d1d!important}' +
    '.pb-cta{background:#b91c1c!important}' +
    '.wj-title span{color:#b91c1c!important}' +
    '.wj-badge{background:#ccc!important;color:#fff!important}' +
    '.wj-badge.active{background:#b91c1c!important;color:#fff!important}' +
    '.wj-dot{border-color:#ccc!important}' +
    '.wj-dot::after{background:#ccc!important}' +
    '.wj-dot.active{border-color:#b91c1c!important}' +
    '.wj-dot.active::after{background:#b91c1c!important}' +
    '.wj-green-line,#wjGreenLine{background:#b91c1c!important}' +
    '.wj-check{color:#999!important}' +
    '.wj-week.active .wj-check{color:#b91c1c!important}' +
    '.wj-items{color:#999!important}' +
    '.wj-week.active .wj-items{color:#333!important}' +
    '.wj-cta{background:#7f1d1d!important}' +
    '.fr5-title span{color:#b91c1c!important}' +
    '.fr5-badge{background:#b91c1c!important}' +
    '.fr5-cta{background:#7f1d1d!important}' +
    '.rs-cmp-outer{background:#4a2020!important}' +
    '.rs-cmp__title2 span{color:#b91c1c!important}' +
    '.rs-cmp__header-cell.rs-cmp__header-good{background:#b91c1c!important}' +
    '.rs-cmp__cell.rs-cmp__cell-good{background:#b91c1c!important}' +
    '.rs-cmp__check{color:#b91c1c!important}' +
    '.rs-cmp__check svg{stroke:#b91c1c!important}' +
    '.rs-cmp__header-us{background:#b91c1c!important}' +
    '.rs-cmp__cta{background:transparent!important}' +
    '.rs-cmp__btn{background:#f5f0e1!important;color:#4a2020!important}' +
    '.rf-section .rf-cta{background:#7f1d1d!important}' +
    '.rf-section .rf-cta:hover{background:#991b1b!important}' +
    '.rf-badge__shield svg{fill:#fca5a5!important}' +
    '.rf-badge__shield svg path{fill:#fca5a5!important}' +
    '.rf-badge__number{color:#7f1d1d!important}' +
    '.rf-badge__label{color:#7f1d1d!important}' +
    '.rp-title span{color:#b91c1c!important}' +
    '.rp-dot-active,.rp-dots .swiper-pagination-bullet-active{background:#b91c1c!important}' +
    '.rs-ann{background:#6b1414!important}' +
    '.rs-ann:hover{background:#991b1b!important}' +
    '.rs-pf-cta,a.rs-pf-cta{background:#a31d1d!important}' +
    '.rs-pf-cta:hover,a.rs-pf-cta:hover{background:#b91c1c!important}' +
    '.marquee-item svg{stroke:#b91c1c!important}' +
    '.marquee-item .check-icon{color:#b91c1c!important}' +
    '#fr-swiper .stars{color:#b91c1c!important}' +
    '.fr-star,.fr-stars{color:#b91c1c!important}' +
    '#fr-swiper .fr-card .stars{color:#b91c1c!important}' +
    '.fr-card-rating .stars{color:#b91c1c!important}' +
    '.sp-item svg{stroke:#b91c1c!important;min-width:16px!important;min-height:16px!important}' +
    '.wj-timeline::before{background:#ddd!important}' +
    '.rating-stars .rating-stars__container--overlay{color:#b91c1c!important}' +
    '.product-form__submit.button,button.atc-button.product-form__submit{--color-button:155,35,53!important;background-color:#9B2335!important;color:#fff!important}' +
    '.product-form__submit.button:hover,button.atc-button.product-form__submit:hover{--color-button:185,28,28!important;background-color:#b91c1c!important}';
  document.head.appendChild(s);
  }

  function doReplacements(){
    /* 0. ATC button color - inline override */
    document.querySelectorAll('.product-form__submit.button, button.atc-button.product-form__submit').forEach(function(b){
      b.style.setProperty('background-color','#9B2335','important');
      b.style.setProperty('color','#fff','important');
    });

    /* 1. Marquee ticker items */
    var tickerMap = {
      "HAVEN'T BEEN SICK IN MONTHS!": "MY READINGS DROPPED 20 POINTS IN 3 WEEKS!",
      "HELPED MY DIGESTION MORE THAN PROBIOTICS": "THE COUGH FROM MY MEDS IS FINALLY GONE",
      "A CLEAN PRODUCT THAT ACTUALLY WORKS": "MY DOCTOR ASKED WHAT I CHANGED",
      "MY GO-TO DURING FLU SEASON": "FIRST TIME UNDER 130 IN SIX YEARS",
      "HAILEY A": "ROBERT M",
      "DANA H": "PATRICIA K",
      "MIKE M": "JAMES T",
      "NELSON A": "LINDA S"
    };
    document.querySelectorAll('.horizontal-ticker__item').forEach(function(el){
      var h = el.innerHTML;
      for(var k in tickerMap){ h = h.split(k).join(tickerMap[k]); }
      el.innerHTML = h;
    });

    /* 2. Hero selling points - text is in span children */
    var spMap = {
      "Immune Support": "Circulation Support",
      "Respiratory Relief": "Blood Pressure",
      "Gut Health": "Nitric Oxide",
      "Energy Boost": "Energy & Clarity",
      "Antiviral Defense": "Heart Health"
    };
    document.querySelectorAll('.sp-item span').forEach(function(sp){
      var t = sp.textContent.trim();
      if(spMap[t]) sp.textContent = spMap[t];
    });

    /* 3. Hero subtitle and heading */
    document.querySelectorAll('p').forEach(function(p){
      if(p.textContent.trim() === '93% of customers report:'){
        p.textContent = 'Trusted by thousands managing blood pressure:';
      }
    });
    document.querySelectorAll('h2').forEach(function(h){
      var t = h.textContent.trim();
      if(t === 'Better sleep & recovery within two weeks' || t === 'Better sleep &\nrecovery within\ntwo weeks'){
        h.textContent = 'Real support for what your medications miss';
      }
    });

    /* 4. Global Resilia -> Vascuflow text replacement */
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while(n = w.nextNode()){
      if(n.textContent.indexOf('Resilia') !== -1){
        n.textContent = n.textContent.split('Resilia').join('Vascuflow');
      }
    }

    /* 5. Featured reviews - direct text replacement */
    var newReviews = [
      "I was on three different blood pressure meds and still couldn\u2019t get below 140. Two weeks on Vascuflow and my morning readings started dropping. My doctor noticed before I even said anything.",
      "I\u2019ve tried CoQ10, fish oil, magnesium \u2014 none of them moved the needle. Vascuflow was the first thing that actually showed up in my readings. And I could feel it too \u2014 less tension, more energy.",
      "I was about to ask my doctor for a third prescription. Started Vascuflow instead. Within a month, my systolic dropped 15 points and I stopped getting that afternoon crash.",
      "After my second medication change in a year, I was exhausted and frustrated. Vascuflow didn\u2019t replace my meds \u2014 but within three weeks, my readings stabilized and I actually had energy again."
    ];
    var frTexts = document.querySelectorAll('.fr-card-text');
    frTexts.forEach(function(el, i){ if(i < newReviews.length) el.textContent = newReviews[i]; });

    /* 6. Featured review quote titles */
    var newTitles = [
      "Wish I\u2019d found this before my third medication.",
      "I stopped feeling like I was circling the drain.",
      "My doctor asked what I changed.",
      "First time under 130 in six years."
    ];
    var frQuotes = document.querySelectorAll('.fr-card-quote, .fr-card-title');
    frQuotes.forEach(function(el, i){ if(i < newTitles.length) el.textContent = newTitles[i]; });

    /* 7. Featured review author names */
    var nameMap = {'Dana H':'Robert M','Mike M':'Patricia K','Hailey A':'James T','Nelson A':'Linda S','Dana H.':'Robert M.','Mike M.':'Patricia K.','Hailey A.':'James T.','Nelson A.':'Linda S.'};
    document.querySelectorAll('.fr-card-author, .fr-card-name').forEach(function(el){
      var t = el.textContent.trim();
      if(nameMap[t]) el.textContent = nameMap[t];
    });

    /* 8. Featured reviews section title */
    document.querySelectorAll('h2').forEach(function(el){
      if(el.textContent.indexOf('They Felt the Shift') !== -1){
        el.innerHTML = el.innerHTML.replace('They Felt the Shift. You Will Too.', 'They Were Doing Everything Right. It Still Wasn\u2019t Enough. Until Now.');
      }
    });

    /* 8. Proven benefits 4th card */
    document.querySelectorAll('.pb-card-title, .pb-front h3, .pb-back p').forEach(function(el){
      var h = el.innerHTML;
      if(h.indexOf('Feel focused, not foggy') !== -1){
        el.innerHTML = h.replace('Feel focused, not foggy', 'Sustained Energy & Mental Clarity');
      }
      if(h.indexOf('Vascuflow helps improve mental clarity') !== -1 || h.indexOf('Resilia helps improve mental clarity') !== -1){
        el.innerHTML = 'By improving circulation and reducing arterial inflammation, Vascuflow helps restore the natural energy and mental clarity that poor cardiovascular health quietly takes away.';
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ doReplacements(); setTimeout(doReplacements, 1500); setTimeout(doReplacements, 4000); });
  } else {
    doReplacements(); setTimeout(doReplacements, 1500); setTimeout(doReplacements, 4000);
  }
})();
